@if (widget(); as widget) {
  <div class="sidebar-content" [class.no-header]="showAllMedications()">
    <mat-tab-group animationDuration="0ms" color="transparent" disablePagination>
      @if (showAllMedications()) {
        <mat-tab>
          <div class="sidebar-content--medications-tab">
            <button aria-label="Back to component" size="small" ttButton variant="transparent" (click)="toggleShowAllMedications(false)">
              <mat-icon [icon]="'chevron-left'" [iconSize]="16" />
              {{ 'Sidebar.BackToComponent' | transloco }}
            </button>

            <sidebar-medications
              [guidelineComponent]="widget.component"
              [isMedicationTab]="true"
              (medicationsChanged)="onMedicationChanged($event)" />
          </div>
        </mat-tab>
      } @else {
        <mat-tab label="{{ 'Details' | transloco }}">
          <div class="sidebar-content--detail-tab">
            <sidebar-title-description
              [description]="widget.component.description"
              [disableDescription]="true"
              [title]="widget.component.title"
              (titleChange)="handleTitleChanged($event)" />

            <tt-divider class="tt-guideline-sidebar_divider" />

            <sidebar-significance-preference
              [component]="widget"
              [hidePreference]="true"
              [significance]="widget.component.significance"
              (significancePreferenceChanged)="onSignificancePreferenceChanged($event)" />

            @if (widget.component.medicationRequests?.length > 0) {
              <tt-divider class="tt-guideline-sidebar_divider" />

              <sidebar-medications
                [guidelineComponent]="widget.component"
                [isMedicationTab]="false"
                (medicationsChanged)="onMedicationChanged($event)"
                (showAllMedicationsToggle)="toggleShowAllMedications($event)" />
            }

            <tt-divider class="tt-guideline-sidebar_divider" />

            <tt-guideline-component-sidebar-basics
              [attachments]="widget.attachments"
              [links]="widget.links"
              [references]="widget.references"
              [resourceTags]="widget.resourceTags"
              (basicsChanged)="handleBasicsChanged($event)" />
          </div>
        </mat-tab>
      }

      @if (!showAllMedications() && !widget.component.proposedComponent) {
        <mat-tab label="{{ 'TechnicalInfo' | transloco }}">
          <sidebar-technical-info [guidelineComponent]="widget.component.activityDefinition" [label]="'ActivityDefinition' | transloco" />
        </mat-tab>
      }
    </mat-tab-group>
  </div>
}
